import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Button } from '../dialog-buttons.component';

import { DialogComponent } from '../dialog.component';

@Component({
    selector: 'productchooser-warning-dialog',
    templateUrl: './productchooser-warning-dialog.component.html',
    styleUrls: ['../dialog.scss'],
    standalone: false
})
export class ProductChooserWarningDialogComponent extends DialogComponent
{
  public productVariant: string;

  constructor(@Inject(MAT_DIALOG_DATA) protected dialogData: any)
  {
    super(dialogData);
    this.productVariant = dialogData.productVariant ?? '';
    this.buttons = {
      primary: Button.CHANGE_PRODUCT,
      secondary: {
        ... Button.KEEP_PRODUCT,
        replacements: {
          productVariant: dialogData.currentProductVariant ?? ''
        },
      }
    };
  }
}
